import { Input } from "antd";
import React from "react";

export default function PostalCodeFormatter(props) {

    const {
        country = "",
        value = "",
        onChange = () => { },
        ...rest
    } = props;

    const formatPostalCode = (_value, _country = "") => {

        if (!_value) {
            return _value;
        }

        if (_country === "Canada") {

            let value = _value.replace(/[^a-zA-Z0-9]/g, '');

            if (value.length > 3) {
                return (
                    value.substr(0, 3) +
                    " " +
                    value.substr(3, 3)
                ).toUpperCase();
            }

            return value.toUpperCase();
        }

        if (_country === "United States") {

            let value = _value.replace(/[^\d]/g, '');

            if (value.length > 5) {
                return (
                    value.substr(0, 5) +
                    "-" +
                    value.substr(5, 4)
                );
            }

            return value;
        }

        return _value;
    };


    const change = (e) => {

        const formatted = formatPostalCode(
            e.target.value,
            country
        );

        e.target.value = formatted;

        onChange(e);
    };

    if (props.display) {
        return formatPostalCode(props.value, props.country);
    }


    return (
        <Input
            {...rest}
            value={value}
            onChange={change}
            name="postal-code"
            autoComplete="postal-code"
            inputMode="text"
            aria-label="Postal Code"
            placeholder="Postal code"
            maxLength={10}
        />
    );
}